import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    gap: 18px;
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`

export const ContainerInputComment = styled.div`
    width: 100%;
    height: auto; 
    padding-bottom: 8px;

    gap: 4px;
    margin-bottom: 16;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    border-bottom: 1px solid #8A92A2;

    >input{
        width: 90%;
        height: 2rem;
        padding: 0 8px;
        border: none;
        border-radius: 4px;
        outline: none;
    }

    >img{
        width: 24px;
        height: auto;
    }
`

export const ContainerInputCommentResponder = styled.div`
    width: 100%;
    height: auto; 
    padding-bottom: 8px;

    gap: 4px;
    margin-bottom: 16;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    border-bottom: 1px solid #8A92A2;

    >input{
        width: 90%;
        height: 2rem;
        padding: 0 8px;
        border: none;
        border-radius: 4px;
        outline: none;
    }

    /* >img:nth-of-type(1){
        width: 15px;
        height: auto;
        margin-bottom: 2px;
    } */

    >img{
        width: 24px;
        height: auto;
    }
`

export const NameProfile = styled.div`
    width: 2rem;
    height: 2rem;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;
    background-color: ${theme.colors.gray.Cinza_2};

    >span{
        cursor: pointer;

        color: #FFFFFF;
    }
`

export const InputComment = styled.input`
    width: 90%;
    height: 2rem;
    padding: 0 8px;
    border: none;
    outline: none;

    /* border-bottom: 1px solid #8A92A2; */
`

export const Close = styled.div`
    width: 22px;
    height: 22px;
    padding: 4px;
    
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 90%;
    background-color: #E8EAED;

    >img{
        width: 14px;
        height: auto;
    }

    @media only screen and (max-width: 768px) {
        width: 38px;
    }
`;

export const ContainerInputCommentOptions = styled.div`
    width: auto;
    height: 24px; 

    gap: 8px;
    display: flex;
    align-items: center;

    >img{
        width: 24px;
        height: auto;
    }
`

export const LoadingComment = styled.div`
  @-webkit-keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
    
  @keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  width: 16px;
  height: 16px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-bottom: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  animation: rotating 0.7s linear infinite;
`;